import type { Framework } from '@toeverything/infra';

import { WorkspaceDBService } from '../db';
import { DocsService } from '../doc';
import { WorkspaceScope } from '../workspace';
import { MeetingsService } from './services/meetings';
import { MeetingsStore } from './stores/meetings';

export { MeetingsService } from './services/meetings';

export const configureMeetingsModule = (framework: Framework) => {
  framework
    .scope(WorkspaceScope)
    .service(MeetingsService, [MeetingsStore, DocsService])
    .store(MeetingsStore, [WorkspaceDBService]);
};
